import React, { useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { withRouter, useHistory, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import InfoDialog from '../Dialog/InfoDialog';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { PayDriver,
    PayShop,
    PaySupplier,
    PaymentRecieved,
    PaymentFastag,
    TransactionHistory,
    TransactionPending
 } from '../TopCard/icons';
 import { numberFormat,getDateInStringDDMMMYYYY } from '../../../utils/utils';
 import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
const useStyles = makeStyles((theme) => ({
  listingCard: {
      boxShadow:'none',
      backgroundColor:"#f6f6f8"
  },
  detailsDiv:{
      marginBottom:12
  },
  titleTxt:{
    fontSize:12,
    textTransform:'uppercase',
    marginBottom:8,
    color:'rgba(11, 19, 35, 0.75);',
    fontWeight:600
  },
  successDiv:{
      display:'flex',
      padding:"12px 16px",
      alignItems:'center',
      backgroundColor:"#00885a",
      borderTopLeftRadius:8,
      borderTopRightRadius:8
  },
  pendingDiv:{
      display:'flex',
      padding:"12px 16px",
      alignItems:'center',
      backgroundColor:"#00885a",
      borderTopLeftRadius:8,
      borderTopRightRadius:8
  },
  successIcon:{
      marginRight:16,
      color:"#fff"
  },
  pendingIcon:{
      marginRight:16,
      color:"#fff"
  },
  headerTxt:{
      fontSize:16,
      fontWeight:600,
      color:"#fff"
  },
  section:{
      marginBottom:12,
      backgroundColor:"#fff",
      borderRadius:8,
      padding:"16px 8px",
      display:'flex',
      flexDirection:'column',
      "&:last-child": {
        marginBottom: 0
      }
  },
  subTitleSec:{
      marginBottom:2,
      display:'flex',
      flexDirection:'row',
      justifyContent:'space-between',
      alignItems:'center'
  },
  valueSec:{
      display:'flex',
      flexDirection:'row',
      justifyContent:'space-between',
      alignItems:'center'
  },
  subTitleTxt:{
      fontSize:12,
      fontWeight:500,
      color: "rgba(11, 19, 35, 0.5);"
  },
  subTitleTxtDiv:{
    display:'flex',
    flexDirection:'row',
    alignItems:'center',
    fontSize:12,
    fontWeight:500,
    color: "rgba(11, 19, 35, 0.5);"
  },
  valueTxt:{
      marginBottom:2
  },
  bullet:{
      fontSize:8,
      margin:"0px 8px",
      color:"#c4c4c4"
  },
  listDivColumn:{
      display:'flex',
      justifyContent:'space-between'
  }
}));
const TripListingCard = (props) => {
  const { 
      title,
      type,
      data
    } = props;
  const classes = useStyles();
  return (
    <>
      <Paper className={classes.listingCard}  >
            <div className={classes.listDivColumn}>
                <Typography className={classes.titleTxt}>Trip Details</Typography>
                <Typography className={classes.titleTxt}>Amount Linked</Typography>
            </div>
            {data && data.tripDetails &&data.tripDetails.length<=0&&<div className={classes.detailsDiv}>
                <div className={classes.section}>
                    <div className={classes.valueSec}>
                        <Typography className={classes.valueTxt}>
                            {data && data.startLocation&&data.destinationLocation?`${data.startLocation} - ${data.destinationLocation}`:""}
                        </Typography>
                        <Typography className={classes.valueTxt}>{data && data.tripAmount?numberFormat(data.tripAmount):data && data.amount?numberFormat(data.amount):""}</Typography>
                    </div>
                    <div className={classes.subTitleSec} >
                        <Typography className={classes.subTitleTxtDiv}>
                            <div>{data && data.startDate?getDateInStringDDMMMYYYY(data.startDate):""}</div>
                            {data && data.vehicleNumber && <>
                                <FiberManualRecordIcon className={classes.bullet} />
                                <div>{data && data.vehicleNumber?data.vehicleNumber:"-/-"}</div>
                            </>}
                        </Typography>
                    </div>
                </div>
            </div>}
            {data && data.tripDetails &&data.tripDetails.length>0&&data.tripDetails.map((data)=>{
                return(
                    <div className={classes.detailsDiv}>
                <div className={classes.section}>
                    <div className={classes.valueSec}>
                        <Typography className={classes.valueTxt}>
                            {data && data.startLocation&&data.destinationLocation?`${data.startLocation} - ${data.destinationLocation}`:""}
                        </Typography>
                        <Typography className={classes.valueTxt}>{data && data.tripAmount?numberFormat(data.tripAmount):data && data.amount?numberFormat(data.amount):""}</Typography>
                    </div>
                    <div className={classes.subTitleSec} >
                        <Typography className={classes.subTitleTxtDiv}>
                            <div>{data && data.startDate?getDateInStringDDMMMYYYY(data.startDate):""}</div>
                            {data && data.vehicleNumber && <>
                                <FiberManualRecordIcon className={classes.bullet} />
                                <div>{data && data.vehicleNumber?data.vehicleNumber:"-/-"}</div>
                            </>}
                        </Typography>
                    </div>
                </div>
            </div>)
            })}
      </Paper>
    </>
  );
}
export default TripListingCard;